import { IModulePath } from 'interfaces/module';
import { VPathKey } from 'lib/history';
import { toJS } from 'mobx';
import { ssm, StoreWithCache } from './store-manager';

const MODULE_KEY = 'VKYC_MODULES';

class ModuleStore {
  private static DEFAULT_MODULE_PATH_VALUE: IModulePath = {
    consent: [VPathKey.CONSENT],
    aadhaarXml: [VPathKey.XML_UPLOAD],
    addhaar: [],
    card: [VPathKey.CARD_SELECT, VPathKey.CARD_UPLOAD, VPathKey.INFO_SUBMIT],
    pan: [VPathKey.PAN_CARD, VPathKey.PAN_INFO],
    ktp: [VPathKey.KTP_CARD, VPathKey.KTP_INFO],
    check: [VPathKey.CHECK],
    main: [VPathKey.WAITING_ROOM, VPathKey.CHATTING_ROOM, VPathKey.COMPLETE],
    precall: [VPathKey.PRECALL],
  };

  private store: StoreWithCache<IModulePath>;

  constructor() {
    this.store = ssm.getStoreWithCache(MODULE_KEY);
    this.store.setDefault(() => ModuleStore.DEFAULT_MODULE_PATH_VALUE);
  }

  public getValue(): IModulePath {
    return this.store.getNotNull();
  }

  public updateValue(value: IModulePath) {
    console.log('IModulePath', value);
    this.store.set(value);
    console.log('updateValue module path', this.store.get());
  }

  public clearData = () => {
    this.store.clear();
  };
}

const moduleStore = new ModuleStore();
export default moduleStore;

['development', 'staging'].includes(process.env.MODE!) &&
  Object.assign(window, { moduleStore, toJS });
